import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import ReactDOM from 'react-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import ClaimTableComponent from '../../components/ClaimTableComponent/ClaimTableComponent';
import { BreakpointTrackerContext } from '@jutro/layout';
import metadata from './ClaimList.metadata.json5';
import { TabSet } from '@jutro/components';
import { Button } from '@jutro/components';
import { ClickableCard } from '@jutro/components';
import styles from './ClaimList.module.scss';

import {ClaimDetailsComponent} from '../ClaimDetails/ClaimDetails';
import PageBannerComponent
    from '../../../../../components/PageBannerComponent/PageBannerComponent';
import FaqPage from 'gw-capability-faq-react';


function ClaimList({history}) {
    let pageRef = React.createRef();
    const handleFileClick = useCallback(() => {
        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: '/claims'
            }
        });
    }, [history]);
    const [pageLoaded, setPageLoaded] = useState(false);

    useEffect(()=>{
        if(!pageLoaded && pageRef.current){
            //document.title = "Customer Enagage Account Management - Claims"
            const element = ReactDOM.findDOMNode(pageRef.current).parentNode; 
            window.setTimeout(() => {
                element.children.claimList.focus()
            }, 1000);
        }        
    },[]);

    const getBackButton = () => {
        const breakpoint = useContext(BreakpointTrackerContext);
        return breakpoint === 'desktop' ? 'Home' : ''
    };

    const overrides = {
        fileClaimButton: {
            to: handleFileClick
        },
        backButton: {
            content: getBackButton()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            claimTableComponent: ClaimTableComponent,
            claimdetailscomponent: ClaimDetailsComponent,
            pagebannercomponent: PageBannerComponent,
            faqpagecomponent:  FaqPage
        },
        resolveCallbackMap: {
            handleFileClick: handleFileClick
        },
    };

    return (
        <div>
            <div id="claimList" role="navigation" title="Landed My Claims Page" tabindex="0" ref={pageRef}></div>
            {renderContentFromMetadata(metadata.pageContent, overrides, resolvers)}
        </div>
    );
}

export default withRouter(ClaimList);
